/**
 * Depósito con dos correos (2026-09-10) — "¿Para qué correo es la bolsa X?"
 * Aparece cuando el backend responde 409 NEED_COURIER_CHOICE al escanear una bolsa:
 * ya hay una bolsa abierta por cada correo y hay que decir cuál se reemplaza.
 */
import { Package, X } from 'lucide-react';
import type { WhCourier } from '../shared';

export function CourierChoiceModal({
  bagCode,
  options,
  onChoose,
  onCancel,
  busy,
}: {
  bagCode: string;
  options: WhCourier[];
  onChoose: (courierKey: string) => void;
  onCancel: () => void;
  busy?: boolean;
}) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 p-4" onClick={onCancel}>
      <div
        className="w-full max-w-md rounded-2xl bg-[var(--color-bg-card)] p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Package size={26} className="text-[var(--color-text-secondary)]" />
            <h2 className="text-lg font-bold text-[var(--color-text)]">
              ¿Para qué correo es la bolsa <span className="font-mono">{bagCode}</span>?
            </h2>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="rounded p-1 text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-hover)]"
            aria-label="Cancelar"
          >
            <X size={18} />
          </button>
        </div>
        <p className="mb-4 text-sm text-[var(--color-text-secondary)]">
          Ya hay una bolsa abierta por cada correo. La bolsa de ese correo se cierra y esta la
          reemplaza.
        </p>
        <div className="grid gap-3">
          {options.map((c) => (
            <button
              key={c.key}
              type="button"
              disabled={busy}
              onClick={() => onChoose(c.key)}
              className="rounded-xl px-4 py-4 text-lg font-bold text-white shadow hover:opacity-90 disabled:opacity-50"
              style={{ backgroundColor: c.color }}
            >
              Es para {c.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
